import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

/**
 * Toggle entity active / inactive status.
 * PUT api/Onboarding/entity-active-inactive
 * Body: { entityPrimaryId: number, isActive: boolean }
 */
export const entityActiveInactiveAction = async (entityPrimaryId, isActive) => {
  try {
    const response = await apiClient.put(ATP_API_URL.ENTITY_ACTIVE_INACTIVE, {
      entityPrimaryId,
      isActive,
    });

    if (response?.status === 200) {
      if (response.data?.success === false) {
        return {
          success: false,
          message: response.data.message || "Failed to update status",
        };
      }
      return {
        success: true,
        message: response.data?.message || "Status updated successfully",
      };
    }

    return { success: false, message: "Failed to update status" };
  } catch (error) {
    return {
      success: false,
      message: error.message || "Failed to update status",
    };
  }
};
